import React, {Component} from 'react';
import {app, config} from "../../app";
import {Button} from 'antd';

class IDetail extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    async componentDidMount() {
      this._isMounted = true;
    }

    componentWillUnmount() {
      this._isMounted = false;
    }

    setData = (data) => app.setStateSync(this, data);

    copyText = async () => {
        let oInput = document.createElement('input');
        oInput.value = '0065';
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象
        document.execCommand("Copy"); // 执行浏览器复制命令
        app.alert("复制成功", "success");
        oInput.remove();
    };

    newPageBaoXian(){
        window.open('https://dmes.e-chinalife.com/m/p/P36000000008/intro?hm_appkey=13ba71e8a7ae279cc9bb0e4f2eb72dd9b6d10e12f64dddb4b8540d9442a72cf5','_blank')
    }

    render() {
        return (
            <div className="insure-details-page">
                <div className="idp-tabs">
                    <div style={{fontSize:'48px'}}>温馨提示</div>
                    <div style={{fontSize:'30px',marginTop:'15px'}}>您即将进入中国人寿保险股份有限公司互联网保险投保页面</div>
                    <div style={{fontSize:'30px',marginTop:'15px',display:'flex',alignItems:'center',justifyContent:'center'}}>
                        <span>销售人员工号后四位：</span>
                        <span ref="jobNumber" style={{color:'red'}}>0065</span>
                        <Button onClick={this.copyText} style={{marginLeft:'15px'}} size="small" type="primary">复制</Button>
                    </div>
                    <Button onClick={this.newPageBaoXian} size="large" style={{width:'200px',marginTop:'50px',letterSpacing:'5px'}} type="primary">前往投保</Button>
                </div>
            </div>
        )
    }
}
export default IDetail;



// WEBPACK FOOTER //
// ./src/routes/insure/IDetail.jsx